import { type DiscountTypesDictionary } from './types';

export const DISCOUNT_TYPES: DiscountTypesDictionary = {
  '': 'offer',
  'payment-method': 'by-payment-method',
  twoPrices: 'two-prices',
};
